import React from "react";

const OptimizedImage = ({
  src,
  alt,
  width,
  height,
  className = "",
  loading = "lazy",
  sizes = "(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw",
  quality = 75,
  ...props
}) => {
  // Generate responsive image sources for different screen sizes
  const generateSrcSet = (baseSrc, baseWidth, baseHeight) => {
    if (
      !baseSrc ||
      baseSrc.startsWith("data:") ||
      baseSrc.startsWith("blob:") ||
      baseSrc.endsWith(".svg") ||
      baseSrc.includes(".svg")
    ) {
      return undefined; // Don't generate srcSet for data URLs, blob URLs, or SVG files
    }

    const sizes = [
      { width: Math.round(baseWidth * 0.5), suffix: "w" },
      { width: Math.round(baseWidth * 0.75), suffix: "w" },
      { width: baseWidth, suffix: "w" },
      { width: Math.round(baseWidth * 1.5), suffix: "w" },
      { width: Math.round(baseWidth * 2), suffix: "w" },
    ];

    return sizes
      .map((size) => `${baseSrc}?w=${size.width}&q=${quality} ${size.suffix}`)
      .join(", ");
  };

  const srcSet =
    width && height ? generateSrcSet(src, width, height) : undefined;

  return (
    <img
      src={src}
      srcSet={srcSet}
      alt={alt}
      width={width}
      height={height}
      className={className}
      loading={loading}
      sizes={sizes}
      decoding="async"
      {...props}
    />
  );
};

export default OptimizedImage;
